import { FormResponse } from "components/ContactForm/FormWrapper"
import { serialize as objectToFormData } from "object-to-formdata"

const apiUrl = process.env.NEXT_PUBLIC_API_URL

export async function uploadAudio(file: File) {
  const fileUploadResponse = await fetch(
    `${apiUrl}web/lead_magnet/files/upload`,
    {
      method: "POST",
      body: objectToFormData({ file }),
    }
  )

  return await fileUploadResponse.json()
}

export async function createAccount(data: any) {
  const response = await fetch(`${apiUrl}app/accounts`, {
    method: "POST",
    body: objectToFormData(data),
  })

  return await response.json()
}

export async function createAudioLead(data) {
  const response = await fetch("/api/create-audio-lead", {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(data),
  })

  return (await response.json()) as FormResponse
}

export async function checkAudioExists(fingerprint) {
  const response = await fetch("/api/check-audio-exists", {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ fingerprint }),
  })

  return (await response.json()) as FormResponse
}

export async function webTracking(data: any) {
  const response = await fetch(`${apiUrl}app/contacts/web_creation`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(data),
  })
  return await response.json()
}
